(function () {
  var CITIES = {
    'Katowice': [50.2649, 19.0238], 'Gliwice': [50.2945, 18.6714], 'Sosnowiec': [50.2863, 19.1041],
    'Tychy': [50.1218, 18.9664], 'Chorzów': [50.2974, 18.9545], 'Zabrze': [50.3249, 18.7857],
    'Bytom': [50.3483, 18.9157], 'Ruda Śląska': [50.2558, 18.8556], 'Rybnik': [50.0971, 18.5463],
    'Jaworzno': [50.2051, 19.275], 'Mysłowice': [50.241, 19.133], 'Siemianowice Śląskie': [50.326, 19.029],
    'Dąbrowa Górnicza': [50.3217, 19.1949], 'Piekary Śląskie': [50.386, 18.946], 'Świętochłowice': [50.2916, 18.9185],
    'Tarnowskie Góry': [50.4457, 18.8611], 'Pszczyna': [49.9794, 18.942], 'Żory': [50.0445, 18.6984],
    'Zawiercie': [50.4864, 19.4127], 'Racibórz': [50.0922, 18.2194], 'Cieszyn': [49.7498, 18.633],
    'Bielsko-Biała': [49.8224, 19.0584], 'Częstochowa': [50.8118, 19.1203], 'Opole': [50.6751, 17.9213],
    'Kraków': [50.0647, 19.945], 'Wrocław': [51.1079, 17.0385], 'Warszawa': [52.2297, 21.0122]
  };

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/ł/g, 'l')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function km(a, b) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (b[0] - a[0]) * toRad, dLng = (b[1] - a[1]) * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a[0] * toRad) * Math.cos(b[0] * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  var CITY_INDEX = {};
  Object.keys(CITIES).forEach(function (name) { CITY_INDEX[norm(name)] = { label: name, c: CITIES[name] }; });

  function init(root) {
    if (!root || root.dataset.osReady) return;
    var data;
    try { data = JSON.parse(root.querySelector('[data-os-data]').textContent); } catch (e) { return; }
    root.dataset.osReady = 'true';

    var kw = root.querySelector('[data-os-keywords]');
    var loc = root.querySelector('[data-os-location]');
    var rad = root.querySelector('[data-os-radius]');
    var clear = root.querySelector('[data-os-clear]');
    var status = root.querySelector('[data-os-status]');
    var empty = root.querySelector('[data-os-empty]');
    var list = root.querySelector('[data-os-cities]');

    Object.keys(CITIES).forEach(function (name) {
      var o = document.createElement('option');
      o.value = name;
      list.appendChild(o);
    });

    var items = data.map(function (d) {
      return { id: String(d.id), lat: d.lat, lng: d.lng, text: norm(d.text) };
    });

    var center = null;
    var tokens = [];
    var geoTimer = null;
    var geoToken = 0;

    function matching() {
      var radius = parseFloat(rad.value) || 20;
      return items.filter(function (it) {
        var textOk = tokens.every(function (t) { return it.text.indexOf(t) !== -1; });
        if (!textOk) return false;
        if (!center) return true;
        if (it.lat === null || it.lng === null) return false;
        return km(center.c, [it.lat, it.lng]) <= radius;
      });
    }

    function applyToGrid(ids, active) {
      document.querySelectorAll('li.product-grid__item[data-product-id]').forEach(function (li) {
        var hide = active && !ids[li.getAttribute('data-product-id')];
        li.classList.toggle('os-hidden', !!hide);
      });
    }

    function run() {
      var active = tokens.length > 0 || !!center;
      var found = matching();
      var ids = {};
      found.forEach(function (it) { ids[it.id] = true; });
      applyToGrid(ids, active);
      clear.hidden = !(active || kw.value || loc.value);
      empty.hidden = !(active && found.length === 0);
      if (active) {
        var where = center ? ' w promieniu +' + (parseFloat(rad.value) || 20) + ' km od: ' + center.label : '';
        status.textContent = 'Pokazano ofert: ' + found.length + ' z ' + items.length + where + '.';
      } else if (loc.value && !center) {
        status.textContent = '';
      } else {
        status.textContent = '';
      }
      document.dispatchEvent(new CustomEvent('landora:offers-filter', {
        detail: {
          active: active,
          ids: found.map(function (it) { return it.id; }),
          center: center ? { lat: center.c[0], lng: center.c[1], label: center.label } : null,
          radiusKm: center ? (parseFloat(rad.value) || 20) : null
        }
      }));
    }

    function setKeywords() {
      tokens = norm(kw.value).split(' ').filter(Boolean);
      run();
    }

    function resolveLocation() {
      var raw = loc.value.trim();
      geoToken++;
      var mine = geoToken;
      if (!raw) { center = null; run(); return; }
      var hit = CITY_INDEX[norm(raw)];
      if (hit) { center = hit; run(); return; }
      status.textContent = 'Szukam lokalizacji…';
      var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=pl&accept-language=pl&q=' + encodeURIComponent(raw);
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (mine !== geoToken) return;
          if (res && res.length) {
            var name = (res[0].display_name || raw).split(',').slice(0, 2).join(',').trim();
            center = { label: name, c: [parseFloat(res[0].lat), parseFloat(res[0].lon)] };
            run();
          } else {
            center = null;
            run();
            status.textContent = 'Nie znaleziono lokalizacji „' + raw + '”. Spróbuj podać miasto lub ulicę z miastem.';
          }
        })
        .catch(function () {
          if (mine !== geoToken) return;
          center = null;
          run();
          status.textContent = 'Nie udało się wyszukać lokalizacji. Wybierz miasto z listy.';
        });
    }

    kw.addEventListener('input', setKeywords);
    kw.addEventListener('search', setKeywords);
    loc.addEventListener('change', resolveLocation);
    loc.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); resolveLocation(); }
    });
    loc.addEventListener('input', function () {
      clearTimeout(geoTimer);
      if (CITY_INDEX[norm(loc.value)]) { geoTimer = setTimeout(resolveLocation, 150); }
      if (!loc.value.trim() && center) { resolveLocation(); }
    });
    rad.addEventListener('change', run);
    clear.addEventListener('click', function () {
      kw.value = '';
      loc.value = '';
      tokens = [];
      center = null;
      geoToken++;
      run();
    });

    // the grid is re-rendered when the native filters change; apply our filter again
    var host = document.querySelector('collection-component') || document.querySelector('main');
    if (host) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (tokens.length > 0 || center) {
            var ids = {};
            matching().forEach(function (it) { ids[it.id] = true; });
            applyToGrid(ids, true);
          }
        }, 60);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  function initAll() { document.querySelectorAll('[data-offers-search]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
